export enum MfaActionTypes {
  REQUEST_SMS_ASYNC_PENDING = "@@mfa/REQUEST_SMS_ASYNC_PENDING",
  REQUEST_SMS_ASYNC_SUCCESS = "@@mfa/REQUEST_SMS_ASYNC_SUCCESS",
  REQUEST_SMS_ASYNC_ERROR = "@@mfa/REQUEST_SMS_ASYNC_ERROR"
}
